"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icon_1 = __importDefault(require("./icon"));
__export(require("./icon"));
exports.default = icon_1.default;
//# sourceMappingURL=index.js.map